// extracted by mini-css-extract-plugin
module.exports = {"SubHeading":"cardModal_SubHeading__3ehIg"};